import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TaskObject } from 'src/app/models/tasks/tasks-table/task-object.model';
import { Task } from 'src/app/services/api/tasks/tasks.service';

export interface DialogData {
  taskNumber: number;
  comment: string;
}

@Component({
  selector: 'app-massive-mode',
  templateUrl: './massive-mode.component.html',
  styleUrls: ['./massive-mode.component.css']
})
export class MassiveModeComponent implements OnInit {

  title = 'Añada un comentario';
  description: string;
  comments: string;
  placeholder = 'Añada un comentario...';
  icon: string; 
  links = []
  info: string;

  dialogRelaunchRef: MatDialogRef<MassiveModeComponent>;

  constructor(
    public dialogRef: MatDialogRef<MassiveModeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      if (data.numberOfTasks == 1) {
        this.description = 'Para poder ' + data.action + ' la tarea seleccionada, es necesario un comentario indicando el motivo:';
      } else {
        this.description = 'Para poder ' + data.action + ' las ' + data.numberOfTasks + ' tareas seleccionadas, es necesario un comentario indicando el motivo:';
      }
      if (data.action === 'relanzar') {
        this.icon = 'refresh';
      }else if(data.action === 'realizar fullRelaunch'){
        this.icon = 'skip_next';
        const links = []
        data.validTasks.forEach((value) =>{
          const path = '/provision/orders/detail';
          const queryParams = { id: value.bussinessCrmId };
          const info = value.bussinessCrmId;
          const link = { path: path, queryParams: queryParams, info: info };
          links.push(link);
        });

        this.links = links;
        this.info = 'Órdenes a las que se les va a aplicar el fullRelaunch';

      }
      else {
        this.icon = 'skip_next';
      }
  }

  ngOnInit() {
  }

  public commentsEvent($event) {
    this.comments = $event;
  }
}
